import { escrowPaymentInitiationArgsToParams } from 'data/api/transformers/arguments/escrow-payment-initiation-args-to-params'
import { InitiateEscrowPaymentArgs } from 'types/api/arguments/initiate-escrow-payment-args'
import { EscrowPaymentResp } from 'types/api/response/escrow-payment-resp'

import { api } from './api'

export const initiateEscrowPayment = (transactionId: number, args: InitiateEscrowPaymentArgs) =>
  api.post<EscrowPaymentResp>(
    `/transactions/${transactionId}/checkout/payment`,
    escrowPaymentInitiationArgsToParams(args),
  )
